/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Event_Group_Index_Oob_MessageInputs */



/**
* | output |
* | --- |
* | "Selected event group index is out of bounds" |
*
* @param {Iframe_Remote_Event_Group_Index_Oob_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_event_group_index_oob_message = /** @type {((inputs?: Iframe_Remote_Event_Group_Index_Oob_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Event_Group_Index_Oob_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Index du groupe d'evenements selectionne hors limites")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Index der ausgewählten Ereignisgruppe liegt außerhalb des gültigen Bereichs.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'indice del gruppo di eventi selezionato è fuori dai limiti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Индекс выбранной группы событий выходит за пределы допустимого диапазона.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El índice del grupo de eventos seleccionado está fuera de los límites")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所选事件组索引超出范围")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベント グループ インデックスは範囲外です")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट समूह सूचकांक सीमा से बाहर है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O índice do grupo de eventos selecionado está fora dos limites.")
	return /** @type {LocalizedString} */ ("Selected event group index is out of bounds")
});